import React from 'react';
import { PencilLine, Sparkles, Share2 } from 'lucide-react';

const STEPS = [
  {
    number: '01',
    title: 'Tell YouBuild',
    body:
      'Tell YouBuild your trade, your area, and your services. Plumber in Brisbane, sparkie on the Gold Coast, cleaner in Newtown, you decide.',
    Icon: PencilLine,
  },
  {
    number: '02',
    title: 'It builds your website',
    body:
      'YouBuild designs the whole site for you: services, reviews, service area, and a working quote request form. Mobile ready, click to call built in.',
    Icon: Sparkles,
  },
  {
    number: '03',
    title: 'Publish and start getting calls',
    body:
      'Hit publish and get a link. Put it on your van, your Google profile, and your quotes. New enquiries land in your Leads inbox.',
    Icon: Share2,
  },
];

const PlatformSteps = () => {
  return (
    <section
      id="how-it-works"
      data-testid="section-how-it-works"
      className="py-24 lg:py-32"
      style={{ backgroundColor: 'var(--yb-bg)', scrollMarginTop: '5rem' }}
    >
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <p className="text-[13px] uppercase tracking-widest mb-4" style={{ color: 'var(--yb-muted)' }}>
            How it works
          </p>
          <h2
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em]"
            style={{ color: 'var(--yb-ink)' }}
          >
            How it works
          </h2>
          <p className="mt-6 text-[16px] leading-relaxed" style={{ color: 'var(--yb-muted)' }}>
            Three steps from a business idea to a real trade website that captures leads. No code, no templates to wrestle with.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STEPS.map(({ number, title, body, Icon }) => (
            <div
              key={number}
              data-testid={`how-step-${number}`}
              className="relative bg-white rounded-2xl border p-7 shadow-[0_6px_24px_-18px_rgba(23,21,59,0.25)]"
              style={{ borderColor: 'var(--yb-border)' }}
            >
              <div className="flex items-center justify-between mb-5">
                <span
                  className="font-serif text-2xl"
                  style={{ color: 'var(--yb-indigo)' }}
                >
                  {number}
                </span>
                <span
                  className="w-9 h-9 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: '#EEF2FF', color: 'var(--yb-indigo)' }}
                >
                  <Icon size={18} />
                </span>
              </div>
              <h3
                className="font-serif text-2xl sm:text-3xl leading-tight tracking-tight"
                style={{ color: 'var(--yb-ink)' }}
              >
                {title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed" style={{ color: 'var(--yb-muted)' }}>
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformSteps;
